import MicNoneIcon from '@mui/icons-material/MicNone';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { Filter } from '@/types/filters';

/**
 * Filters for note content: only video and audio filters remain.
 */
export const filters: Filter[] = [
  {
    id: 'video',
    name: 'Video',
    icon: VideocamOutlinedIcon,
  },
  {
    id: 'audio',
    name: 'Audio',
    icon: MicNoneIcon,
  },
];

export const filtersToProcessingType = (filters: Filter[]) => {
  if (filters.length === 0) {
    return null;
  }

  const processingTypes = filters.map((filter) => {
    switch (filter.id) {
      case 'video':
        return 'video';
      case 'audio':
        return 'audio';
    }
  });
  if (processingTypes.includes('video') && processingTypes.includes('audio')) {
    return null;
  }
  if (processingTypes.includes('video')) {
    return 'video';
  }
  if (processingTypes.includes('audio')) {
    return 'audio';
  }
};
